import { subscribeWS, unsubscribeWS } from 'modules/websocket/WSManager';
import * as services from 'modules/websocket/services/wsConversationUpdate';
import { onConversationUpdate } from 'modules/conference/actions/_newConversationActions/onConversationUpdate';

const WS_CONVERSATION_UPDATE = 'WS_CONVERSATION_UPDATE';

export const startObserveConversationUpdate = () => (dispatch, getState) =>
  subscribeWS(
    services.WS_CONVERSATION_UPDATE,
    { userId: getState().auth.userInfo.userId },
    (...args) => dispatch(onConversationUpdate(...args)),
    WS_CONVERSATION_UPDATE,
  );

export const stopObserveConversationUpdate = () => unsubscribeWS(WS_CONVERSATION_UPDATE);
